import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import Directive from './directives'
import 'animate.css'
import VConsole from 'vconsole'
import {
  mcSetTitle,
  mcSetRight,
  mcToast,
  mcClosePage
} from '@/utils/mcSdkUtils'
import {
  setItem,
  getItem,
  getCorpId,
  getSearchValueByKey,
  getPageTitle
} from '@/utils/comUtils'

import { PAGE_IN_MODULE, INNER_CORP, DEBUGGERID } from '@/utils/constUtils'

import '@/utils/plugin'
Vue.config.productionTip = false

let isBack = false
window.addEventListener('popstate', e => {
  isBack = true
})

const mudules = Object.keys(PAGE_IN_MODULE)
let app = null
// 路由跳转时 导航钩子
router.beforeEach(async (to, from, next) => {
  if (to.path !== '/' && !store.state.semesterSetting.schoolYear) {
    try {
      await store.dispatch('handlerCheckSemester')
    } catch (error) {
      console.log(error)
    }
  }
  if (
    (to.path === '/guardian' && from.path === '/home') ||
    (from.path === '/guardian' && to.path === '/home')
  ) {
    return mcClosePage()
  }
  // 初始化 默认隐藏右侧 左侧返回
  if (to.meta.modular) {
    mcSetTitle(getPageTitle(to))
  }
  setTimeout(() => {
    mcSetRight({
      control: false,
      show: false
    })
  }, 0)
  const { $moduleId } = to.query
  const _moduleIdList = (store.getters.skuInfo || {}).moduleIdList || []
  const _meta = to.meta || {}
  const _modular = `${
    _meta.field
      ? _meta.modularObj[(to.query || {})[_meta.field]]
      : $moduleId || _meta.modular
  }`
  const _title = getPageTitle(to, false)
  if (
    (_title || _meta.field) &&
    _modular !== '-1' &&
    _moduleIdList.length &&
    _moduleIdList.indexOf(_modular) < 0
  ) {
    await router.replace('/home')
    return mcToast({ msg: `暂无${_title}权限` })
  }
  // 拦截路由 直接进入全量 在根据全量的modular判断是否为灰度 如果是灰度就拦截把全量路由更改为灰度路由
  let _module = (to.path || '').match(/^\/(.*?)\//)
  let _bus = _module && _module[1]
  if (_bus && mudules.indexOf(_bus) > -1) {
    isBack = false
    let replace = to.query._rp
    delete to.query._rp

    next({
      path: `/${
        (getItem('graybus') || '').indexOf(PAGE_IN_MODULE[_bus]) > -1
          ? 'gray'
          : 'full'
      }${to.path}`,
      query: to.query,
      params: to.params,
      replace
    })
  } else {
    if (isBack) {
      isBack = false
      if (to.path === '/home') {
        store.commit('clearCachedViews', [])
      } else {
        if (from.meta.keepAlive) {
          store.commit('deleteCachedViewsByPath', from.name)
        }
      }
    } else {
      let toName = to.path.replace(/\/(gray|full)/gi, '').slice(1)
      /* 路由缓存淘汰
       * 首先判断路由是否需要缓存 根据route.meta.keepAlive，如果为true，就把路由存入到store中
       * 如果在某个业务下进行切换，比如请假，请假对应的界面会被缓存
       */
      if (to.meta.keepAlive) {
        // 如果来源路由和目标路由的一级菜单不一致
        let toPrefix = toName.split('/')
        // 假设A-B-C A和B都缓存 A进入B在返回A 这时候B要从缓存中移除 首页-A-B-A 那么此时缓存的对象是【A-B】
        // B返回A 需要把A后面所有的对象清除即可
        store.commit('addCachedViews', {
          path: toPrefix.join('/'),
          name: to.name
        })
      }
    }
    next()
  }
})

router.afterEach((to, from, failure) => {
  mcSetTitle(getPageTitle(to))
  app && app.$downloadingLayer && app.$downloadingLayer.hide()
})
Vue.use(Directive)

/* eslint-disable no-new */
let _options = {
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
}
const debugId = getSearchValueByKey('debugId')
const noDebugId = getSearchValueByKey('noDebugId')
setItem('debugId', debugId)
if (
  (INNER_CORP.indexOf(getCorpId()) > -1 || debugId === DEBUGGERID) &&
  noDebugId !== DEBUGGERID
) {
  _options.VConsole = new VConsole()
}
app = new Vue(_options)
export default app
